import customAxios from '@/utils/custom-axios';

export const BABYBOOK_LOOKUP_RESULT = {
  SUCCESS: 1,
  ERROR: -9,
};

export const BabybookService = {
  getWhitelistedTokens: () => {
    return customAxios.get(`${process.env.VUE_APP_API}/babybook/tokens`);
  },
};
